import { createReducer } from "deox";

import { reportDownloaded, reportDownloading, reportError, reportInit } from "./statementReportStateActions";
import { purge } from "../purge/purgeStateActions";

export interface StatementReportState {
  isError: boolean;
  isDownloading: boolean;
  isDownloaded: boolean;
  payload: Blob | null;
  billingCycleId: number | null;
  statementId?: number | null;
  debtCategoryId?: number | null;
}

export const initialState: StatementReportState = {
  isError: false,
  isDownloading: false,
  isDownloaded: false,
  payload: null,
  billingCycleId: null,
  statementId: null,
  debtCategoryId: null,
};

const statementReducer = createReducer(initialState, (handleAction) => [
  handleAction(
    reportDownloaded,
    (state, action): StatementReportState => ({
      ...state,
      isDownloading: false,
      isError: false,
      isDownloaded: true,
      payload: action.payload,
      billingCycleId: null,
      statementId: null,
      debtCategoryId: null,
    })
  ),
  handleAction(
    reportDownloading,
    (state, action): StatementReportState => ({
      ...state,
      isDownloading: true,
      payload: null,
      isError: false,
      isDownloaded: false,
      billingCycleId: action.payload,
      statementId: action.payload,
      debtCategoryId: action.payload,
    })
  ),
  handleAction(
    reportError,
    (state, action): StatementReportState => ({
      ...state,
      isError: true,
      isDownloading: false,
      isDownloaded: false,
      payload: null,
      billingCycleId: null,
      statementId: null,
      debtCategoryId: null,
    })
  ),
  handleAction(purge, () => initialState),
  handleAction(reportInit, () => initialState),
]);

export default statementReducer;
